.room {
  position: relative;
  flex: none;
  width: 100vw;
  height: 100%;
  display: grid;
  place-items: start center;
  overflow: hidden;
}

.scene {
  position: relative;
  z-index: 1;
  width: min(100vw, 150dvh);
  aspect-ratio: 3 / 2;
  overflow: hidden;
  container-type: inline-size;
  background: transparent;
}

.background {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.background img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  image-rendering: pixelated;
}

@media (max-width: 680px) {
  .room::after {
    content: '';
    position: absolute;
    z-index: 0;
    left: 0;
    right: 0;
    top: min(210vw, 140dvh);
    bottom: 0;
    pointer-events: none;
    background: linear-gradient(180deg, var(--mobile-edge) 0%, #050809 72%, #050809 100%);
  }

  .scene {
    left: calc((100vw - min(140vw, 93.333dvh)) / 2);
    width: min(140vw, 93.333dvh);
    aspect-ratio: 2 / 3;
  }
}

@media (min-width: 681px) {
  .scene {
    position: absolute;
    top: 0;
    left: 50%;
    width: 150dvh;
    max-width: none;
    height: 100dvh;
    margin-left: -75dvh;
    overflow: visible;
  }

  .wideRoom .background {
    left: 50%;
    right: auto;
    width: 166.6667%;
    height: 100%;
    margin-left: -83.3333%;
    -webkit-mask-image: linear-gradient(90deg, transparent 0%, #000 3%, #000 97%, transparent 100%);
    mask-image: linear-gradient(90deg, transparent 0%, #000 3%, #000 97%, transparent 100%);
  }
}
